import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";
export class AssignSoDto {
    @ApiProperty()
    @IsNotEmpty({message:"Plant should not be empty"})
    plantId: number;
    @ApiProperty()
    @IsNotEmpty({message:"Lot Number should not be empty"})
    lotNo: string;
    @ApiProperty()
    @IsNotEmpty({message:"SO Number should not be empty"})
    soNumber: number;
    @ApiProperty()
    @IsNotEmpty({message:"SO Item Number should not be empty"})
    soItemNumber: number;
    @ApiProperty()
    @IsNotEmpty({message:"Headless count should not be empty"})
    count: number;
    @ApiProperty()
    @IsNotEmpty({message:"Quantity should not be empty"})
    quantity: number;
    @ApiProperty()
    @IsNotEmpty({message:"Created user should not be empty"})
    createdUser: string;
    @ApiProperty()
    @IsNotEmpty({message:"boxes should not be empty"})
    boxes: number;
    @ApiProperty()
    @IsNotEmpty({message:"planned SO Id should not be empty"})
    plannedSoId?: number;

}